<template>
  <div
    class="language-selector"
  >
    <v-select
      v-model="language"
      :items="formattedLanguages"
      label="initials"
      item-text="formatted"
      item-value="i18n_locale"
      class="language-selector__select"
      return-object
      solo
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { applyHighchartsLocale } from '@/utils/highcharts-locale';

const LOCALE_STORAGE_KEY = 'studio_i18n_locale';

const LANGUAGES = {
  pt: {
    label: 'Português',
    initials: 'PT',
    i18n_locale: 'pt',
  },
  en: {
    label: 'English',
    initials: 'EN',
    i18n_locale: 'en',
  },
  es: {
    label: 'Español',
    initials: 'ES',
    i18n_locale: 'es',
  },
};

export default {
  name: 'LanguageSelector',
  data() {
    return {
      languages: LANGUAGES,
    };
  },
  computed: {
    language: {
      get() {
        // Use $i18n.locale directly so the v-select always reflects the actual
        // locale. This prevents the revert loop caused by stale activeLanguage.
        return this.languages[this.$i18n.locale] || this.languages.pt;
      },
      set(newLanguage) {
        // Guard: skip if locale is already correct (prevents cascade when
        // Vuetify re-emits @input after an external :value prop change)
        if (newLanguage.i18n_locale === this.$i18n.locale) return;
        this.saveLanguage(newLanguage);
        localStorage.setItem(LOCALE_STORAGE_KEY, newLanguage.i18n_locale);
        this.$i18n.locale = newLanguage.i18n_locale;
        this.$vuetify.lang.current = newLanguage.i18n_locale;
        applyHighchartsLocale(newLanguage.i18n_locale);
      },
    },
    formattedLanguages() {
      return Object.values(this.languages).map(lang => ({
        ...lang,
        formatted: `${lang.label} (${lang.initials})`,
      }));
    },
  },
  created() {
    this.syncLocaleFromStorage();
  },
  methods: {
    ...mapActions('dashboard', [
      'saveLanguage',
    ]),
    syncLocaleFromStorage() {
      const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
      const locale = stored || this.$i18n.locale || 'pt';
      const matched = this.languages[locale];
      if (matched) {
        this.$i18n.locale = matched.i18n_locale;
        this.$vuetify.lang.current = matched.i18n_locale;
      }
    },
  },
};
</script>

<style scoped lang="scss">
  .language-selector {
    display: flex;
    justify-content: flex-end;

    &__select {
      position: relative;
      width: 150px !important;
      height: 24px !important;
      padding: 0 24px 0 var(--ds-spacing-stack-quark) !important;
      font-size: var(--ds-font-size-xs);
      line-height: var(--ds-font-line-height-dense);
      text-align: left;
      text-transform: none;
    }
  }
</style>
